import React,{Component} from 'react';
import {Tooltip,Fab,Badge} from '@mui/material';
import {SpeakerNotes} from '@mui/icons-material';
import {connect} from 'react-redux';
import {showError,showMessage,confirmAction} from '../../actions/uiActions';
import CreateUserNote from './CreateUserNote';
import moment from 'moment';
import AccountsApi from '../../api/accounts';
import DOMPurify from "dompurify";
import { AiFillPushpin } from "react-icons/ai";
import { PiPushPinSimpleSlashBold } from "react-icons/pi";
class UserNotes extends Component {

    state={
        expanded:false,
        create:false,
        notes:[],
        loaded: false,
        editingNote: null,
        pinnedNotes: [],
        showPinnedNotes: false,
    }
    componentDidUpdate()
    {
        if(this.props.account&&!this.state.loaded)
        {
            const notes = this.props.account.notes || [];
            const updatedNotes = notes.sort((a, b) => b.timestamp - a.timestamp);
            const pinnedNotes = updatedNotes.filter(item => item.isPinned);
            this.setState({
                notes: updatedNotes,
                expanded: notes.filter(note=>!this.isRead(note)).length>0,
                loaded: true,
                pinnedNotes
            })
        }
    }
    addNote=()=>{
        this.setState({create:true})
    }
    editNotes = (note) => {
        this.setState({create:true, editingNote: note})
    }
    renderNoNotesMessage=()=>{
        return <div className="text-center">
        <p className="notice">No notes have been added for this user.</p>
        </div>;
    }
    getAuthor=(note)=>{
        if(note.author===this.props.user.id)
            return "You";
        else
            return note.createdBy;
    }
    delete = (note) => {
        this.props.confirmAction("You are going to delete this note, therefore other users of the CRM platform will no longer be able to see it. Do you want to proceed anyway?",
            async () => {
                try {
                    await AccountsApi.deleteNote(this.props.account._id, note.id)
                    if (note.isPinned) {
                        this.setState({ pinnedNotes: this.state.pinnedNotes.filter(n => n.id != note.id) })
                    }
                    this.setState({ notes: this.state.notes.filter(n => n.id != note.id) })
                } catch (error) {
                    this.props.showError(error)
                }
            });
    }
    read=(note)=>{
        AccountsApi.readNote(this.props.account._id,note.id).then(success=>this.setState({notes:this.state.notes.map(n=>{
            if(n.id==note.id)
                n.read=[...n.read,this.props.user.id]
            return n;
        })})).catch(error=>this.props.showError());
    }
    updateNotePinStatus = async (note) => {
        try {
            const { notes } = this.state
            const existingNote = notes.find(item => item.id === note.id);
            const body = {
                isPinned: !existingNote.isPinned
            }
            const newNote = await AccountsApi.updateNotePinStatus(this.props.account._id, body, existingNote.id)
            const updatedNote = notes.map(item => {
                if (item.id === existingNote.id) {
                    return newNote;
                }
                return item;
            })
            const pinnedNotes = updatedNote.filter(item => item.isPinned)
            this.setState({ notes: updatedNote, pinnedNotes });
            if (pinnedNotes.length === 0) {
                this.setState({showPinnedNotes: false});
            }
        } catch (error) {
            this.props.showError(error)
        }
    }
    onUpdateNote = (notes, note) => {
        const { editingNote } = this.state
        const existingNote = notes.find(item => item.id === editingNote.id);
        return notes.map(item => {
            if (item.id === existingNote.id) {
                return { ...existingNote, ...note };
            }
            return item;
        })
    }
    onNoteAdded = (note, isEditMode) => {
        if (isEditMode) {
            const { editingNote, notes, pinnedNotes } = this.state
            const updatedNote = this.onUpdateNote(notes, note)
            this.setState({ notes: updatedNote });
            if (editingNote.isPinned) {
                const updatedPinnedNotes = this.onUpdateNote(pinnedNotes, note)
                this.setState({ pinnedNotes: updatedPinnedNotes });
            }
        }
        else {
            this.setState({ notes: [note, ...this.state.notes] })
        }
    }
    createMarkup = (html) => {
        return {
            __html: DOMPurify.sanitize(html)
        };
    };

    renderList=()=>{
        return <ul className='note-item'>
        {this.state.notes.map((note,index)=><li key={`user-note-${index}`} className={!this.isRead(note)&&"unread"}>
            <div className="note-header">
                <div>{note.event}</div>
                <div>{moment(note.timestamp, "X").format("MMM Do, YYYY @ h:mm a")}</div>
            </div>
            <div style={{
                display: "flex", width: "100%",
                justifyContent: "space-between", alignItems: "center"
            }}>
                <h2>{this.getAuthor(note)} wrote:</h2>
                <div onClick={() => this.updateNotePinStatus(note)} style={{cursor:"pointer"}}>
                   {note.isPinned ? <PiPushPinSimpleSlashBold/> : <AiFillPushpin />}
                </div>
            </div>
            <p dangerouslySetInnerHTML={this.createMarkup(note.note)}></p>
            {!this.isRead(note)&&<button onClick={()=>this.read(note)}>Confirm reading</button>}
            {note.author===this.props.user.id&&<button className="link" onClick={()=>this.delete(note)}>Delete</button>}
            {note.author === this.props.user.id && <button className="link" onClick={() => this.editNotes(note)}>Edit</button>}
            {note.editedAt &&<div className="note-header link">Last Edited: {moment(note.editedAt,"X").format("MMM Do, YYYY @ h:mm a")}</div>}
        </li>)}
    </ul>;
    }
    renderPinnedNotes = () => {
        return (
            <ul className="pinned_notes note-item">
                {this.state.pinnedNotes.map((note, index) => <li key={`user-note-${index}`} className={!this.isRead(note) && "unread"}>
                    <div className="note-header">
                        <div>{note.event}</div>
                        <div>{moment(note.timestamp, "X").format("MMM Do, YYYY @ h:mm a")}</div>
                    </div>
                    <div style={{
                        display: "flex", width: "100%",
                        justifyContent: "space-between", alignItems: "center"
                    }}>
                        <h2>{this.getAuthor(note)} wrote:</h2>
                        <div onClick={() => this.updateNotePinStatus(note)} style={{ cursor: "pointer" }}>
                            {note.isPinned ? <PiPushPinSimpleSlashBold /> : <AiFillPushpin />}
                        </div>
                    </div>
                    <p dangerouslySetInnerHTML={this.createMarkup(note.note)}></p>
                </li>)}
            </ul>
        )
    }
    renderPinnedNotesText = () => {
        if (this.state.pinnedNotes.length > 1) {
            return `View ${this.state.pinnedNotes.length} pinned messages`
        } else {
            return `View 1 pinned message`
        }
    }
    renderNotes=()=>{
        return <div id="user-notes" className="animated fadeIn">
            <h1>User Notes<button onClick={this.addNote}>+ Add note</button></h1>
                <div className="pinned_container">
                {this.state.pinnedNotes.length > 0 && !this.state.showPinnedNotes &&
                    <button className='pinned' onClick={() => this.setState({ showPinnedNotes: true })}>
                        <span>{this.renderPinnedNotesText()}</span>
                    </button>
                }
                {this.state.pinnedNotes.length > 0 && this.state.showPinnedNotes &&
                    <button className="pinned" onClick={() => this.setState({ showPinnedNotes: false })}>
                        <span>Click to hide</span>
                    </button>}
            </div>

            {this.state.pinnedNotes.length > 0 && this.state.showPinnedNotes && this.renderPinnedNotes()}
            {this.state.loading && this.renderLoader()}
            {this.state.notes.length === 0 && this.renderNoNotesMessage()}
            {this.state.notes.length > 0 && this.renderList()}
            {this.renderButton()}
            {this.state.create&&<CreateUserNote editingNote={this.state.editingNote} onNoteAdded={this.onNoteAdded} account={this.props.account} onClose={()=>this.setState({create:false, editingNote: null})} />}
        </div>
    }
    unreadNotesCount=()=>this.state.notes.filter(note=>!this.isRead(note)).length;


    isRead=(note)=>{
        return note.read.find(id=>id==this.props.user.id)?true:false;
    };
    renderButton=()=>{
        const unreadNotes=this.unreadNotesCount();
        const button=<Fab onClick={()=>this.setState({expanded:!this.state.expanded})} variant="fab" color="secondary" aria-label="Add" >
        <SpeakerNotes />
    </Fab>;
        return <Tooltip title="User Notes" placement="top" className="floating-button pink">
            {unreadNotes>0?<Badge className={"animated heartBeat infinite slower"} badgeContent={unreadNotes} color="primary">{button}</Badge>:button}
        </Tooltip>;
    }
    render()
    {
        return this.props.account?(this.state.expanded?this.renderNotes():this.renderButton()):<></>
    }
}
const mapStateToProps= state =>{
    return {
        user:state.auth.account
    }};
export default connect(mapStateToProps,{showError,showMessage,confirmAction})(UserNotes);